import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import Footer from "./components/Footer";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockListingProducts from "./blocks/BlockListingProducts";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";
import ArchiveStore from "./pages/ArchiveStore";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	NavsFull.init();
	Footer.init();

	// Blocks
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockListingProducts.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();

	// Pages
	ArchiveStore.init();


	Share.init();
});
